import React from 'react';
import { connect } from 'react-redux';
// Shared imports
import '../../../SharedUI/index';
// AssetsPopup imports
import AssetPickerContainer from './Container';
import { closeAssetPicker } from '../../actions/assetPickerActions';

class AssetPicker extends React.Component {
    handlePickerClose = () => {
        const { dispatch, assetPicker } = this.props;
        const { onPickerClose } = assetPicker;
        onPickerClose();
        dispatch(closeAssetPicker());
    };

    render = () => {
        const { assetPicker } = this.props;
        const { active, position, size, type, currentAsset, onPickAsset } = assetPicker;

        return (
            <div className={`asset-picker asset-picker-${type} ${active ? 'active' : ''}`}>
                <div className="main-asset-picker">
                    <div className="asset-picker-overlay" onClick={this.handlePickerClose} />
                    <AssetPickerContainer type={type} currentAsset={currentAsset} onPickAsset={onPickAsset} position={position} size={size} />
                </div>
            </div>
        );
    };
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    assetPicker: state.assetPicker
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AssetPicker);
